function openInfoPopup(icon, title, text) {
  const dialog = document.getElementById('info-popup-dialog');
  if (!dialog) {
    console.error('Info popup dialog element not found');
    return;
  }

  const iconElement = dialog.querySelector('.info-popup-icon');
  const titleElement = dialog.querySelector('.info-popup-content .info-popup-title');
  const textElement = dialog.querySelector('.info-popup-text');

  if (iconElement) {
    if (typeof icon === 'string' && icon.trim() !== '') {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = icon;
      iconElement.innerHTML = tempDiv.innerHTML;
    } else {
      iconElement.innerHTML = '';
    }
  }

  if (titleElement) {
    titleElement.textContent = title || '';
  }

  if (textElement) {
    if (typeof text === 'string' && text.trim() !== '') {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = text;
      textElement.innerHTML = tempDiv.innerHTML;
    } else {
      textElement.innerHTML = '';
    }
  }

  dialog.classList.add('is-open');
  dialog.showModal();
  
  document.body.classList.add('info-popup-open');
}

function closeInfoPopup() {
  const dialog = document.getElementById('info-popup-dialog');
  if (!dialog) {
    return;
  }

  dialog.classList.remove('is-open');
  dialog.close();
  
  document.body.classList.remove('info-popup-open');
}

document.addEventListener('DOMContentLoaded', function() {
  const dialog = document.getElementById('info-popup-dialog');
  if (!dialog) {
    return;
  }

  const closeButton = document.getElementById('info-popup-close');
  if (closeButton) {
    closeButton.addEventListener('click', closeInfoPopup);
  }

  dialog.addEventListener('click', function(event) {
    if (event.target === dialog) {
      closeInfoPopup();
    }
  });

  dialog.addEventListener('cancel', function(event) {
    event.preventDefault();
    closeInfoPopup();
  });

  const popupButtons = document.querySelectorAll('.info-popup-button');
  popupButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      const icon = this.getAttribute('data-popup-icon') || '';
      const title = this.getAttribute('data-popup-title') || '';
      const content = this.getAttribute('data-popup-content') || '';
      
      openInfoPopup(icon, title, content);
    });
  });
});

window.openInfoPopup = openInfoPopup;
window.closeInfoPopup = closeInfoPopup;
